/**
 * 常用常量
 */

/** 数字布尔值 */
export enum BOOLEAN {
  NO,
  YES
}
export const BOOLEAN_OPTIONS = [
  { value: BOOLEAN.YES, label: '是' },
  { value: BOOLEAN.NO, label: '否' }
]
/** BOOLEAN 取反 */
export function reverseBoolean(value: BOOLEAN) {
  return Number(!value)
}

/** 表格排序策略 - 指定顺序 */
export enum SORT_ORDERS_TYPE {
  /** 升序 */
  ASC = 'ascending',
  /** 降序 */
  DESC = 'descending'
}
/** 表格排序策略 - 默认顺序 */
export const SORT_ORDERS_TYPE_NONE = null

/** 摇钱树费率规则图片的url */
export const CASH_COW_RATE_RULE_URL = `https://webcdn.leyopharm.com/web/Money_Tree_Rate_Rules.png?tempid=${Math.random()}`

/** 系统名称 */
export const DOCUMENT_TITLE = '供应商开放平台'
